import React, { useEffect, useState } from 'react';
import { BwjSidePanel } from '../../../../framework/components/bwj-side-panel';
import * as formService from '../../form-services/blocks-creator';
import { BwjButtonType } from '../../../../framework/components/bwj-button';
import { BwjGrid, Col, Row } from '../../../../framework/components/bwj-layout';
import { Spacing } from '../../../../framework/components/bwj-layout/styles';
import { BwjTextField } from '../../../../framework/components/bwj-text-field';
import { BwjDateField } from '../../../../framework/components/bwj-date-field';
import { BwjCheckbox } from '../../../../framework/components/bwj-checkbox';
import { ICreateTimeBlocksRequest } from '../../../../entities-generated/models/time-block/create-time-blocks-request';

interface ICreateTimeBlocksPanelProps {
  invokePanelDisplay: {} | undefined;
  onCreateTimeBlocks: (request: ICreateTimeBlocksRequest) => void;
}

const subscriberId = 'Panel.CreateTimeBlocks';

const getMinDate = () => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}

export const CreateTimeBlocksPanel: React.FunctionComponent<ICreateTimeBlocksPanelProps> = (props) => {
  const { invokePanelDisplay } = props;
  const formModel = formService.useFormModel(subscriberId);
  const [showPanel, setShowPanel] = useState(false);

  useEffect(() => {
    if(!!invokePanelDisplay) {
      formService.initializeService({});
      setShowPanel(true);
    } else {
      setShowPanel(false);
    }
  }, [invokePanelDisplay]);

  const onClosePanel = () => setShowPanel(false);

  const onCreateTimeBlocks = () => {
    formService.validateAndUpdateModel()
    .then(result => {
      if(result.isValid) {
        const request = formService.toCreateRequest();
        props.onCreateTimeBlocks(request);
        setShowPanel(false);
      }
    });
  }

  return (
    <BwjSidePanel
      showPanel={showPanel}
      title={'Create Time Blocks'}
      footerButtons={[{
        buttonStyle: BwjButtonType.PrimaryStandard,
        text: 'Create time blocks',
        onClick: onCreateTimeBlocks
      }, {
        buttonStyle: BwjButtonType.DefaultStandard,
        text: 'Cancel',
        onClick: onClosePanel
      }]}
      onDismiss={onClosePanel}
    >
      <BwjGrid>
        <Row bottomSpacing={Spacing.Large}>
          <Col small={12}>
            <BwjDateField
              id={formService.date.id}
              required={true}
              label={formModel.date.description}
              onUpdate={formService.date.onUpdate}
              input={formModel.date}
              minDate={getMinDate()}
            />
          </Col>
        </Row>
        <Row bottomSpacing={Spacing.Large}>
          <Col small={12}>
            <BwjTextField
              id={formService.numBlocks.id}
              required={true}
              label={formService.numBlocks.description}
              onUpdate={formService.numBlocks.onUpdate}
              input={formModel.numBlocks}
              filter={/^\d*$/}
            />
          </Col>
        </Row>
        <Row bottomSpacing={Spacing.Large}>
          <Col small={12}>
            <BwjCheckbox
              id={formService.isBillableTime.id}
              label={formService.isBillableTime.description}
              checked={formModel.isBillableTime}
              onChange={formService.isBillableTime.onUpdate}
            />
          </Col>
        </Row>
      </BwjGrid>
    </BwjSidePanel>
  );
};
